/**
 * Позиция объявления в пине для аналитики: с 1, в порядке объявлений пина - так их показывают
 * листалка мультипина на десктопе и шторка на телефоне. null - объявления в пине нет.
 */
export function getPositionInPin(pinRealtyIds: number[], realtyId: number): number | null {
  const index = pinRealtyIds.indexOf(realtyId);

  return index === -1 ? null : index + 1;
}
